import api from '../api';

export function listPosts(accountId) {
    return api.get(`/posts?account_id=${accountId}`).then(response => response.data);
}

export function getPost(postId) {
    return api.get(`/posts/${postId}`).then(response => response.data);
}

export function share(postId) {
    return api.post(`/posts`, {
        'account_id': accountId,
        'message': message
    }).then(response => response.data);
}

export function createPost(accountId, message) {
    return api.post(`/posts`, {
        'account_id': accountId,
        'message': message
    }).then(response => response.data);
}

export function editPost(id, {message, media}) {
    const payload = {};

    if (message) {
        payload.message = message;
    }

    if (media) {
        payload.media = media;
    }

    return api.patch(`/posts/${id}`, payload).then(response => response.data);
}

export function editPostReply(postId, replyId, message) {
    return api.post(`/posts/${postId}/edit_reply`, {
        'replyId': replyId,
        'message': message
    }).then(response => response.data);
}

export function editPostReplies(postId, replies) {
    return api.post(`/posts/${postId}/edit_replies`, {
        'replies': replies
    }).then(response => response.data);
}

export function removeImage(postId, image) {
    return api.post(`/posts/${postId}/remove_image`, {
        'image': image
    }).then(response => response.data);
}

export function schedulePost(postId, schedule) {
    return api.post(`/posts/${postId}/schedule`, {
        'scheduled_for': schedule
    }).then(response => response.data);
}

export function unschedulePost(postId) {
    return api.post(`/posts/${postId}/unschedule`).then(response => response.data);
}

export function sharePost(postId) {
    return api.post(`/posts/${postId}/share`, null, {
        timeout: 0
    }).then(response => response.data);
}

export function removePost(postId) {
    return api.delete(`/posts/${postId}`).then(response => response.data);
}

export function removePostReply(postId, replyId) {
    return api.post(`/posts/${postId}/remove_reply`, {
        'replyId': replyId
    }).then(response => response.data);
}

export function removePostReplies(postId, replyIds) {
    return api.post(`/posts/${postId}/remove_replies`, {
        'replies': replyIds
    }).then(response => response.data);
}
